export default __webpack_public_path__ + "static/media/device.7a3c171c.svg";